import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import MainLayout from "./mainLayout";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />} path="/kitchen-builder" />
      </Routes>
    </BrowserRouter>
  );
}
